import m from "../../geodata/es2015/tajikistanHigh";
window.am4geodata_tajikistanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/tajikistanHigh.js
// module id = null
// module chunks = 